"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserState = getUserState;
function getUserState(state) {
    if (state.platform.user?.status === 'done') {
        if (state.platform.user.data) {
            return state.platform.user.data.state;
        }
        else {
            throw new Error('Invalid platform state, user data is not set.');
        }
    }
    else {
        throw new Error('Cannot get user state, user is not logged in.');
    }
}
